enum ERROR_STRINGS {
    INCORRECT_PIN = 'incorrect transaction pin'
};

enum ERROR_CODES {
    INCORRECT_PIN = 'BUYER_INVALID_CRED'
}

export const StringConstants = {
    USER_ACCEPTED_TERMS_CONDITIONS: 'gpx_tc',
    IMEI_sessionStr: 'currentUserPayexIMEI',
    DEVICEID_sessionStr: 'currentUserPayexDeviceId',
    USER_sessionStr: 'currentUserPayex',
    USER_INVALID_LOGINATTEMPTS: 'currentUserInvalidLoginAttempts',
    USER_loggedInWithOTP: 'currentUserLoggedInWithOTP',
    INVOICE_invoiceToPayStr: 'currentInvoiceToPay',
    INVOICE_multipayStr: 'multipayInvoicesToPay',
    CURRENT_Invoice: 'currentInvoice',
    CURRENT_Creditnote: 'currentCN',
    INVOICE_multipayGroupStr: 'multipayInvoicesGroup',
    INVOICE_multipayGroupStr_TO_PAY: 'multipayInvoicesGroupToPay',
    INVOICE_multipayGroupStr_TO_PAY_SELECTED: 'multipayInvoicesGroupToPaySelected',
    CURRENT_DOCUMENT: 'currentDocument',
    CURRENT_Transaction: 'currentSelectedTransaction',
    CURRENT_Language:'CurrentLanguage',
    CURRENT_CURRENCY: "CurrentCurrency",
    SUPPORTED_Languages: 'SupportedLanguages',
    LANDING_STATE: 'landingState',
    MANAGE_AUTOPAY_LIST: 'manageAutoPayList',
    EVENTS: {
        INIT_SCROLL_LIST: 'initScrollList',
        LOAD_SCROLL_DATA: 'loadScrollData'
    },
    LANGUAGES: {
      ENGLISH: 'en',
      FRENCH: 'fr',
      HINDI: 'in'
  },
    MESSAGES: {
        'VALID_MOBILE_NUMBER_AND_EMAIL':'Please enter a valid mobile number or email.',
        'MOBILE_NUMBER_IS_REQUIRED':'Please enter a valid mobile no. or email to login',
        'PASSWORD_IS_REQUIRED':'Please enter PIN to log in',
        'PLEASE_WAIT': 'Please Wait...',
        'INVOICE_OVERDUE_WARN_PAY_SCREEN': `Please note that you may not be eligible for Cash Discounts if you have Overdue Invoices.`,
        'INVOICE_PAY_DISCOUNT_WARN': `*Availability of cash discount is subject to cash discount date slab or clearance of all overdue invoices.`,
        'CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET_CNSPLIT': 'The Credit Note amount should be equal to or greater than the Invoice amount.',
        'CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET': 'The Credit Note amount should be equal to the Invoice amount.',
        'CREDITNOTE_SELECTION_CNSPLIT_INVALID_SELECTION': 'You have selected excess credit note(s).',
        'INCORRECT_TRANSACTION_PIN_MAX_ATTEMPTS': 'You have exceeded the attempts to enter Transaction PIN to pay. Please try again later.',
        'BANNER_REPSPONSE_YES': 'Thank you for your interest. Our team will be shortly in touch with you.',
        'BANNER_REPSPONSE_NO': 'We thank you for your response.',
        'DOC_NOT_FOUND': 'Document not found, please contact distributor',
        'PAYMENT_ERROR': 'Something went wrong with payment, if you have completed the payment, data will be updated in some time.',
        'PAY_URL_ERROR': 'Oops, the invoice you are trying to pay is not payable anymore. Please contact your distributor.',
        INVALID_SERVICE_RESPONSE:'We are unable to process your request at the moment, please try again later.',
        SERVER_GENERAL_ERROR: 'Oops! There seems to be server issue, please give us some time to discipline the server.',
        SESSION_TIMEOUT: 'Your session has timed-out because of inactivity, Please login again to continue.',
        PAYMENT_METHOD_NOT_ALLOWED: 'Selected payment option is not available for this invoice(s). Please select a different payment option',
        NO_PENDING_CREDIT_NOTES: 'No more active credit notes available for you.',
        NO_USED_CREDIT_NOTES: 'It seems you have not used any Credit note.',
        PIN_RESET_FROM_LOGIN: 'Your pin is successfully updated, please login with new pin.',
        CREDIT_LIMIT_EXCEED: 'Net paying amount is greater than your available credit limit. Please select a different payment option.'
    },
    //We have global handlers for displaying errors, for some of the messages we want to pass error to service / controller, declare them here
    PASS_ON_ERRORS: [ERROR_STRINGS.INCORRECT_PIN],
    AUTH_ROUTE_DATA_STATE: 'authRouteData',
    PASS_ON_ERROR_CODES: [ERROR_CODES.INCORRECT_PIN],
    PASS_ON_ENDPOINTS : []
};
